import { render, staticRenderFns } from "./emailandsmslist.vue?vue&type=template&id=4ca272f9&scoped=true&"
import script from "./emailandsmslist.vue?vue&type=script&lang=js&"
export * from "./emailandsmslist.vue?vue&type=script&lang=js&"
import style0 from "./emailandsmslist.vue?vue&type=style&index=0&id=4ca272f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca272f9",
  null
  
)

export default component.exports